import { render, staticRenderFns } from "./purchase_product_list.vue?vue&type=template&id=079cd7e0&scoped=true"
import script from "./purchase_product_list.vue?vue&type=script&lang=js"
export * from "./purchase_product_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079cd7e0",
  null
  
)

export default component.exports